import React from 'react'

import RequestFormField from "../../../model/settings/field"
import FieldFormElement from "../../../../../../core/fields3/render/form-elemnent"
import FormManager from "../../../../../../core/gd-form/common/form-manager"
import FormError from "../../../../../../core/gd-form/common/form-error/form-error"
import {FieldType} from "../../../../../../core/fields3/field-type"
import RequestForm from "../../../model/request-form"

type Props = {
    requestForm : RequestForm
    formField   : RequestFormField
    form        : FormManager
}

const debug = false
// const debug = "FormRowField"

export default class FormRowField extends React.Component<Props> {
    render() {
        debug && console.log(debug, 'render', this.props.formField.field, this.props)

        const formElementClasses = Classes({
            'w-300': this.props.formField.field && ![
                FieldType.STRING,
                FieldType.NUMBER,
                FieldType.TEXT,
                FieldType.EMAIL
            ].includes(this.props.formField.field.type)
        })

        // all form text shoudl be 4 lines height
        let rows : undefined | number = undefined
        if (this.props.formField.field?.type === FieldType.TEXT) {
            rows = 4
        }

        return (
            <div className="form-row">
                <div className="form-row-content">
                    <div className="title">
                        {this.props.formField.label}
                        {this.props.formField.isRequired &&
                            <span className="required">*</span>}
                    </div>
                    {this.props.formField.description &&
                        <div className="desc">{this.props.formField.description}</div>}

                    <div className="element">
                        {this.props.formField.field &&
                            <React.Fragment>
                                <FieldFormElement className = {formElementClasses}
                                                  field     = {this.props.formField.field}
                                                  form      = {this.props.form}
                                                  model     = {this.props.requestForm}
                                                  rows      = {rows}
                                                  disabled  = {false}/>
                                <FormError className    = {formElementClasses}
                                           form         = {this.props.form}
                                           name         = {this.props.formField.field.fieldId} />
                            </React.Fragment>}
                    </div>
                </div>
            </div>
        )
    }
}
